import state from './schedule.state'
import mutations from './schedule.mutations'
import actions from './schedule.actions'

export default {
  state,
  mutations,
  actions
}
